import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { entityMessages } from 'src/features/entity/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';
import { pageTitles } from 'src/features/navigation/utils/messages';
import PeopleTable from 'src/features/entity/components/table/PeopleTable';
import GroupsTable from 'src/features/entity/components/table/GroupsTable';
import { PERMISSION } from 'src/features/auth';
import useHasPermissions from 'src/hooks/useHasPermissions';

const EntityTables = () => {
    const { formatMessage } = useIntl();
    const permissionAccessEntities = useHasPermissions([PERMISSION.ACCESS_ENTITIES]);

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(pageTitles.entitiesCRM));
        return removeTitle;
    }, [removeTitle, setTitle]);

    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            <Tabs defaultValue="people">
                <TabsList>
                    {permissionAccessEntities && (
                        <TabsTrigger value="people">
                            <FormattedMessage {...entityMessages.people} />
                        </TabsTrigger>
                    )}

                    {permissionAccessEntities && (
                        <TabsTrigger value="groups">
                            <FormattedMessage {...entityMessages.groups} />
                        </TabsTrigger>
                    )}
                </TabsList>

                {permissionAccessEntities && (
                    <TabsContent value="people" className="w-full">
                        <PeopleTable />
                    </TabsContent>
                )}

                {permissionAccessEntities && (
                    <TabsContent value="groups">
                        <GroupsTable />
                    </TabsContent>
                )}
            </Tabs>
        </div>
    );
};

export default EntityTables;
